import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  Body,
  DELETE,
  GET,
  POST,
  PUT,
  Params,
  PaginatedResult,
  Query,
} from '@app/core/api';

import {WorkspaceMarkSeenDto, WorkspaceMemberInviteDto, WorkspaceMemberUpdateDto} from './dto';
import type {
  WorkspaceActivityLogResult,
  WorkspaceMemberResult,
  WorkspaceResult,
} from './workspace-api.models';

@ApiController('api/app/workspaces')
@Injectable({
  providedIn: 'root',
})
export class WorkspaceApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @GET('')
  getWorkspaces(): Observable<ApiResponse<WorkspaceResult[]>> {
    return {} as Observable<ApiResponse<WorkspaceResult[]>>;
  }

  @GET('/:workspaceId/members')
  getMembers(@Params('workspaceId') workspaceId: number): Observable<ApiResponse<WorkspaceMemberResult[]>> {
    return {} as Observable<ApiResponse<WorkspaceMemberResult[]>>;
  }

  @POST('/:workspaceId/members')
  inviteMember(
    @Params('workspaceId') workspaceId: number,
    @Body() dto: WorkspaceMemberInviteDto,
  ): Observable<ApiResponse<WorkspaceMemberResult>> {
    return {} as Observable<ApiResponse<WorkspaceMemberResult>>;
  }

  @PUT('/:workspaceId/members/:memberId')
  updateMember(
    @Params('workspaceId') workspaceId: number,
    @Params('memberId') memberId: number,
    @Body() dto: WorkspaceMemberUpdateDto,
  ): Observable<ApiResponse<WorkspaceMemberResult>> {
    return {} as Observable<ApiResponse<WorkspaceMemberResult>>;
  }

  @POST('/:workspaceId/members/:memberId/disable')
  disableMember(
    @Params('workspaceId') workspaceId: number,
    @Params('memberId') memberId: number,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @POST('/:workspaceId/members/:memberId/enable')
  enableMember(
    @Params('workspaceId') workspaceId: number,
    @Params('memberId') memberId: number,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @DELETE('/:workspaceId/members/:memberId')
  deleteMember(
    @Params('workspaceId') workspaceId: number,
    @Params('memberId') memberId: number,
  ): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }

  @GET('/:workspaceId/activity-logs')
  getActivityLogs(
    @Params('workspaceId') workspaceId: number,
    @Query() query: Record<string, unknown>,
  ): Observable<ApiResponse<PaginatedResult<WorkspaceActivityLogResult>>> {
    return {} as Observable<ApiResponse<PaginatedResult<WorkspaceActivityLogResult>>>;
  }

  @POST('/seen')
  markSeen(@Body() dto: WorkspaceMarkSeenDto): Observable<ApiResponse<boolean>> {
    return {} as Observable<ApiResponse<boolean>>;
  }
}
